import { useSyncExternalStore } from 'react';

let _wsConnected = false;
const _listeners = new Set<() => void>();

function subscribe(cb: () => void) {
  _listeners.add(cb);
  return () => _listeners.delete(cb);
}

function getSnapshot() {
  return _wsConnected;
}

export function setWsConnected(value: boolean) {
  if (_wsConnected !== value) {
    _wsConnected = value;
    _listeners.forEach((cb) => cb());
  }
}

export function useIsWsConnected(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function getAdaptivePollingInterval(): number {
  return _wsConnected ? 60_000 : 5_000;
}
